import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { logout } from './authSlice';
import api from './config';

const initialState = {
  calendarDays: [],
  calendarLoading: false,
  calendarError: null
};

export const fetchCalendarSummary = createAsyncThunk(
  'attendance/fetchCalendarSummary',
  async ({ collaborationId, year, month }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.get(
        `/collaboration/${collaborationId}/calendar-summary`,
        { params: { year, month } }
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) dispatch(logout());
      return rejectWithValue(error.response?.data || error);
    }
  }
);

const attendanceSlice = createSlice({
  name: 'attendance',
  initialState,
  reducers: {
    clearCalendarSummary: (state) => {
      state.calendarDays = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCalendarSummary.pending, (state) => {
        state.calendarLoading = true;
        state.calendarError = null;
      })
      .addCase(fetchCalendarSummary.fulfilled, (state, { payload }) => {
        state.calendarLoading = false;
        state.calendarDays = payload || [];
      })
      .addCase(fetchCalendarSummary.rejected, (state, { payload }) => {
        state.calendarLoading = false;
        state.calendarDays = [];
        state.calendarError = payload?.message || 'Error fetching calendar summary';
      });
  }
});

export const { clearCalendarSummary } = attendanceSlice.actions;

export default attendanceSlice.reducer;
